import { roles } from '../types';
import { getSessionInfo } from './getSessionInfo';

export const getUserRoles = () => {
	const { userInfo } = getSessionInfo();

	const userRoles = userInfo?.roles;

	return {
		isOwner: userRoles?.includes(roles.owner),
		isManager: userRoles?.includes(roles.manager),
		isAccountant: userRoles?.includes(roles.accountant),
	};
};
